module.exports = __webpack_public_path__ + "static/2-8034de33ae5ff7cda533581304e756dd.jpg";